import { render, staticRenderFns } from "./SkinThicknessTemplate.vue?vue&type=template&id=063d3918"
import script from "./SkinThicknessTemplate.vue?vue&type=script&lang=js"
export * from "./SkinThicknessTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports